import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'
import { FieldType } from '@wix/wix-data-schema-types'

export const productSpecification: DataBindingComponentModel = {
  panel: {
    height: 576,
    title: 'wixui_ProductSpecification_dataBinding_panelTitle',
    helpId: '',
  },
  isConnectGfppEnabled: true,
  sections: [
    {
      role: 'ProductSpecificationRole',
      bindings: [
        {
          title: 'wixui_ProductSpecification_dataBinding_items_label',
          prop: 'items',
          supportedFieldTypes: [FieldType.array],
          defaultFieldType: FieldType.array,
        },
      ],
    },
  ],
  compactErrorPanel: true,
}
